// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__1CTzX","LeftBtn":"Header_LeftBtn__1Dz2I","RightBtn":"Header_RightBtn__2T89m","DarkBackground":"Header_DarkBackground__34bSe"};